import Swal from 'sweetalert2';

export const showSuccess = (message: string, title: string = 'Success!'): Promise<any> => {
  return Swal.fire({
    icon: 'success',
    title,
    text: message,
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
  });
};

export const showError = (message: string, title: string = 'Error!'): Promise<any> => {
  return Swal.fire({
    icon: 'error',
    title,
    text: message,
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
  });
};

export const showWarning = (message: string, title: string = 'Warning!'): Promise<any> => {
  return Swal.fire({
    icon: 'warning',
    title,
    text: message,
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
  });
};

export const showInfo = (message: string, title: string = 'Info'): Promise<any> => {
  return Swal.fire({
    icon: 'info',
    title,
    text: message,
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });
};

export const showConfirm = (
  message: string,
  title: string = 'Are you sure?',
  confirmText: string = 'Yes',
  cancelText: string = 'Cancel'
): Promise<any> => {
  return Swal.fire({
    icon: 'question',
    title,
    text: message,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: '#E91E63',
    cancelButtonColor: '#6c757d',
  });
};

export const showDeleteConfirm = (itemName: string = 'this item'): Promise<any> => {
  return Swal.fire({
    icon: 'warning',
    title: 'Are you sure?',
    text: `You are about to delete ${itemName}. This action cannot be undone!`,
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#EF4444',
    cancelButtonColor: '#6c757d',
  });
};

export const showSuccessModal = (message: string, title: string = 'Success!'): Promise<any> => {
  return Swal.fire({
    icon: 'success',
    title,
    text: message,
    confirmButtonColor: '#E91E63',
  });
};

export const showErrorModal = (message: string, title: string = 'Error!'): Promise<any> => {
  return Swal.fire({
    icon: 'error',
    title,
    text: message,
    confirmButtonColor: '#E91E63',
  });
};
